ValidationEngine = App.loadClass "core::ValidationEngine"
SelectBox = App.loadClass "core::SelectBox"
accounting = App.loadClass "bower::accounting/accounting"

class exports.RuppOrdersDialogLinesHandler extends Handler

    init: () ->
        @everythingLoaded = false
        @layoutUrl = 'backend/grower/rupp-orders/load-layout-lines'
        @layoutSelector = "#orders_steps_container"
        @loadLayout()
        @fetchPrices = 0

    afterLoadLayout: (selector, response) =>
        if response.status?.type isnt 'success'
            return

        ths = this

        # Add line
        @line_id = 0
        $('#btn_add_line').bind 'click', () ->
            line_id = $(this).data('id')
            $(this).removeData('id')
            line_id = ths.line_id if not line_id?

            data = $('.add-line-tmpl').render({ line_id: line_id })
            data = $($.parseHTML(data))
            data.appendTo('.orders_lines_container')

            # Set some data attributes on all the form elements so we can
            # know where to save their data
            data.find('.order-data').attr('data-dynamic-btn', '#btn_add_line')
            data.find('.order-data').attr('data-dynamic-id', line_id)
            data.find('.btn_line_delete').attr('data-dynamic-id', line_id)

            # Handle masking for the units input
            data.find('.txt_line_units').mask('?9999999', { placeholder: "" })

            # Populate the technology and brand
            brands = ths.taffyObjects['hybrids']([
                {
                    "available":
                        "gt": 0
                    "disabled":
                        "is": false
                },
                {
                    "id":
                        "is": parseInt(ths.parent.saveData.lines[line_id]?.hybrids_id) ? ""
                }
            ]).order('display_name').distinct('id', 'display_name')

            technologies = ths.taffyObjects['hybrids']([
                {
                    "available":
                        "gt": 0
                    "disabled":
                        "is": false
                },
                {
                    "id":
                        "is": parseInt(ths.parent.saveData.lines[line_id]?.hybrids_id) ? ""
                }
            ]).order('trait_packages_name').distinct('trait_packages_id', 'trait_packages_name')


            #technologies = ths.taffyObjects['trait_packages']().order('name').distinct('trait_package_id','name')
            #brands = ths.taffyObjects['trait_packages']().order('brand_name').distinct('brand_id','brand_name')
            SelectBox.render(technologies, $(data).find('.sel_line_technology'))
            SelectBox.render(brands, $(data).find('.sel_line_brand'))

            ths.line_id = parseInt(line_id) + 1

            ths.validator?.revalidateInput('.validate-lines')

        # Delete line
        $('.orders_lines_container').delegate '.btn_line_delete', 'click', (e) ->
            ths.parent.deleteFormData('lines', $(this).data('dynamic-id'))
            $(this).closest('.line_header').remove()

        # Change trait package
        $('.orders_lines_container').delegate '.sel_line_technology', 'change', (e) ->
            ths.fetchPrices++
            line_id = $(this).data 'dynamic-id'
            technology_id = $(this).val()

            criteria = {}
            if technology_id isnt ''
                criteria =
                    'trait_packages_id':
                        '==': technology_id

            stage = ths.parent.saveData.lines[line_id]?.status_name ? ""

            if stage is ""
                criteria['available'] = "gt": 0
            else if stage is "Ordered"
                hid         = ths.parent.saveData.lines[line_id].hybrids_id

                technology  = $.extend({ "available": { "gt": 0 } }, criteria)
                current     = $.extend({ "id": { "is": hid } }, criteria)

                criteria    = [
                    technology,
                    current
                ]

            validBrands = ths.taffyObjects["hybrids"](criteria).distinct('id', 'display_name')
            dropdown = $(this).closest('.line_header').find('.sel_line_brand')
            SelectBox.render validBrands, dropdown
            if not technology_id
                dropdown.val('')
                ths.validator?.revalidateInput dropdown

            ths.fetchPrices--
            ths.updatePrices()

        # Change brand
        $('.orders_lines_container').delegate '.sel_line_brand', 'change', (e) ->
            ths.fetchPrices++

            # Update the validation group
            $(this).closest('tr').find('.validate-hybrid-avail').data('validate-group', $(this).val())

            hybrid = ths.taffyObjects["hybrids"](
                'id':
                    '==': $(this).val()
            ).select('trait_packages_id', 'available_treatments', 'default_treatment_id')

            if hybrid.length
                $(this).closest('.line_header').find('.sel_line_technology').val(hybrid[0][0]).change()

                # Update list of treatments
                tmts = hybrid[0][1]
            else
                # Clear list of treatments
                tmts = []

            sel_tmt = $(this).closest('.line_header').find('.sel_line_treatment')
            val = sel_tmt.val()
            SelectBox.render tmts, sel_tmt

            # Select default treatment
            if val
                sel_tmt.val val
            else if hybrid.length
                sel_tmt.val hybrid[0][2]
            sel_tmt.trigger 'change'

            # Find the default price for this hybrid
            zone_name = ths.taffyObjects['zones'](
                'id':
                    '==': ths.parent.saveData.pricing_zones_id
            ).select('name')[0]

            if zone_name
                column_name = switch zone_name
                    when '1 - WC IN' then 'rupp_price_1wcin'
                    when '3 - NW OH MI' then 'rupp_price_3nwohmi'
                    when '4 - SE OH PAS' then 'rupp_price_4seohpas'
                    when '9 - E - IN' then 'rupp_price_9ein'
            else
                column_name = "rupp_price"

            price = ths.taffyObjects["hybrids"](
                'id':
                    '==': $(this).val()
            ).select(column_name)[0]

            $(this).parents('tr').find('.txt_line_unit_price').val(price)

            ths.fetchPrices--
            ths.updatePrices()

        # Change tmt
        $('.orders_lines_container').delegate '.sel_line_treatment', 'change', (e) ->
            ths.fetchPrices++

            tmt = $(this).parents('tr').find('.sel_line_treatment').val()

            t = ths.taffyObjects["treatment_prices"](
                'id':
                    '==': tmt
            ).first()

            $(this).parents('tr').find('.txt_line_tmt_price').val(t.price)

            ths.fetchPrices--
            ths.updatePrices()


        # Change qty
        $('.orders_lines_container').delegate '.txt_line_units', 'change', (e) ->
            ths.fetchPrices++

            brand = $(this).parents('tr').find('.sel_line_brand').val()

            h = ths.taffyObjects["hybrids"](
                'id':
                    '==': brand
            ).first()

            ths.fetchPrices--
            ths.updatePrices()

        # Change unit price or treatment price
        $('.orders_lines_container').delegate '.txt_line_unit_price, .txt_line_tmt_price', 'change', (e) ->
            input = $(e.target)
            money = parseFloat(input.val()).toFixed(2)
            if money is 'NaN'
                money = ''
            input.val money
            ths.updatePrices()

        if @parent.editable
            # Handle validation
            @validator = new ValidationEngine()

            # Stop validating until the 'next' button is clicked
            @validator.stopValidating()

            @validator.makeFormValidator 'lines', '#lines_container', '#lines_errors', (valid) =>
                @parent.gotoNext() if (valid)

            @validator.registerRule
                selector: '.validate-lines'
                text: 'You must have at least one line on the order'
                func: (elem) ->
                    return elem.closest('table').find('tbody tr').length > 0

            @validator.registerRule
                selector: '.validate-hybrid-avail'
                text: (elems, name) ->
                    hybrid_id = parseInt($(elems[0]).data('validate-group'))
                    h = ths.taffyObjects["hybrids"](
                        id:
                            '==': hybrid_id
                    ).first()

                    return "There are not enough units of #{h.display_name} to fulfill your request. #{h.display_name}'s availability is #{h.available} units"
                group:
                    attr: 'validate-group'
                    name: 'Hybrid %g'
                func: (elems) ->
                    qty = 0

                    for elem in elems
                        elem = $(elem)

                        # We only care about counting qtys
                        continue if not elem.is('.txt_line_units')

                        # These are both required
                        brand = $(elem.parents('tr').find('.sel_line_brand')[0])
                        units = $(elem.parents('tr').find('.txt_line_units')[0])
                        continue if not brand.val() or not units.val()

                        qty += parseInt(units.val())

                    # Calculate how many units this hybrid had before
                    # We don't care about the status because https://www.pivotaltracker.com/story/show/118751589
                    hybrid_id = parseInt($(elems[0]).data('validate-group'))
                    old_units = 0
                    for index, line of ths.parent.saveData.lines
                        if parseInt(line.original_hybrids_id) is hybrid_id
                            #console.log line.original_qty
                            old_units += parseInt(line.original_qty)

                    # At this point, we've counted all the quantities for this hybrid
                    # Now check it against the available inventory
                    hybrid = ths.taffyObjects["hybrids"](
                        id:
                            '==': hybrid_id
                    ).first()

                    #console.log "#{qty} <= #{hybrid.available} + #{old_units}"

                    return true if qty <= old_units # https://www.pivotaltracker.com/story/show/110173228
                    return qty <= parseInt(hybrid.available) + old_units

                @validator.registerRule
                    selector: 'input[name=qty]'
                    text: 'You may not increase the quantity on a disabled product'
                    func: (elem) =>
                        brand = elem.closest('tr').find('.sel_line_brand').val()
                        disabled = @taffyObjects['hybrids'](
                            'id':
                                '==': brand
                        ).select('disabled')[0]

                        # If the selected product is not active, then check that the qty didn't increase
                        if disabled
                            old_qty = elem.attr('data-orig-qty')
                            new_qty = elem.val()
                            return parseInt(new_qty) <= parseInt(old_qty)

                        return true

        @parent.loadFormData()

        # Set a data attribute on quantity boxes with the original qty (used for validation)
        for qty in $('input[name=qty]')
            $(qty).attr 'data-orig-qty', $(qty).val()

        @parent.dialog.find('.message_writer').message_writer( autoHide: false )

        @everythingLoaded = true

        @updatePrices()


    updatePrices: () ->
        return if not @everythingLoaded
        return if @fetchPrices > 0

        @parent.saveFormData()

        # Make a post to the backend to get the pricing
        $.post 'backend/grower/rupp-orders/new-pricing-lines', JSON.stringify(@parent.saveData), (data) =>
            # If something goes wrong, zero out everything
            if not data?
                $('.line_header .unit_price,.tmt_price,.ext_price').text('')
            else
                data = $.parseJSON data
                for i, arr of data
                    row = $(".sel_line_brand[data-dynamic-id='#{i}']").closest('tr')
                    arr['ext_price'] = 0 if not arr['ext_price']
                    row.find('.ext_price').text(accounting.formatMoney(arr['ext_price']))


    afterLoadData: () ->
        $('#btn_orders_next').prop('disabled', false)
